import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IRequestPermissionPanelStyles {
  root?: IStyle;
}

export interface IRequestPermissionPanelClassNames {
  root: string;
}

export const requestPermissionPanelStylesDefault = (_theme: IH2OTheme): Partial<IRequestPermissionPanelStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});
